import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { ActionType, ProColumns } from "@ant-design/pro-components";
import { Button, Card } from "antd";

import { DeleteFilled, KeyOutlined } from "@ant-design/icons";

import { AntDProTable } from "../../../components/antdProTable";

import { SubscriptionSchema } from "../../../model/subscriptionSchema.schema";
import { subscriptionService } from "../../../services/subscriptionService";
import moment from "moment";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

//Start
export function AllSubscriptionHistoryListPage(prop: { subscription: string }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  let tableRef = useRef<ActionType>();

  const columns: ProColumns<SubscriptionSchema>[] = [
    {
      title: t("Create Date"),
      dataIndex: "createDate",
      defaultSortOrder:"descend",
      hideInSearch: true,
      hideInTable: false,
      renderText(text, record, index, action) {
        return moment(new Date(text)).format("yyyy-MM-DD HH:mm:ss");
      },
    },
    {
      title: t("API Key"),
      dataIndex: "apiKey",
      hideInSearch: true,
      hideInTable: false,
      sorter: false,
    },
    {
      title: t("Action"),
      dataIndex: "action",
      hideInSearch: true,
      hideInTable: false,
      sorter: false,
    },
    
    {
      title: t("Token"),
      dataIndex: "token",
      hideInSearch: true,
      hideInTable: false,
      sorter: false,
    },
    {
      title: t("Document"),
      dataIndex: "documentId",
      hideInSearch: true,
      hideInTable: false,
      sorter: false,
      render: (text, record, index, action) => {
        if(text){
          return <Link to={`/dashboard/admin-document/${text}`}>{text}</Link>;
        }
        return null
      }
    },
  ];

  return (
    <>
      <Card style={{ marginTop: 20 }} loading={loading}>
        <AntDProTable<SubscriptionSchema>
          filterType={"light"}
          size={"small"}
          onRefCallback={(ref: any) => {
            tableRef.current = ref.current;
          }}
          pageSizeOptions={[10, 20, 50, 100, 200]}
          columns={columns}
          rowKey="id"
          scroll={{ x: "max-content" }}
          toolbar={{
            actions: [],
          }}
          request={(
            params,
            sort,
            filter,
            skip,
            take,
            where,
            sortBy,
            order,
            cb
          ) => {
            /// setLoading(true);
            where.subscription = prop.subscription;
            subscriptionService
              .listAllSubscriptionHistory({
                params,
                sort,
                filter,
                skip,
                take,
                where,
                sortBy,
                order,
              })
              .then((res) => {
                //setLoading(false);
                if (res.success) {
                  cb({
                    data: res.result,
                    total: res.recordTotal,
                    success: true,
                    page: params.current,
                  });
                } else {
                  cb({
                    data: [],
                    total: 0,
                    success: false,
                    page: params.current,
                  });
                }
              })
              .catch((err) => {
                setLoading(false);
                cb({
                  data: [],
                  total: 0,
                  success: false,
                  page: params.current,
                });
              });
          }}
        />
      </Card>
    </>
  );
}
